export const target = {
  name: 'target',
  friendlyName: 'Anchor Target',
  type: 'string',
  helperText:
    'The element ID that the anchor will scroll to. Should be unique to the page.',
  regex: {
    pattern: '^[a-z0-9]+(-[a-z0-9]+)*$',
    options: 'g',
    message:
      'Please enter a valid element ID. It should only contain lowercase letters, numbers, and hyphens.'
  }
};
